export function target() {
  return !!this.settingsInstance;
}

export function migrate() {
  const { instances, instanceList, settingsInstance } = this;
  const { data } = instances[settingsInstance];
  const moduleProps = instances[instanceList[0]];

  if (!this.data) {
    this.data = { ...data, ...moduleProps.data };
    this.module = moduleProps.module;
    this.name = moduleProps.name;
  }

  // These delete won't actually delete from database, but are necessary to not break
  // containerSettings getter. Change later to set as null.
  delete this.settingsInstance;
  delete this.instanceList;
  delete this.instances;
}
